import AuthStorage from "~/modules/auth/storage";
import process from "@/utils/process";

/* Interceptor para refresh innecesario */
export default function bearerToken(
  context: any,
  aborter: AbortController
) {
  if (process.server || !AuthStorage.token) return;

  context.options.headers.set("Authorization", "Bearer " + AuthStorage.token);
  return context;
}
